export default "__VITE_ASSET__5b80848c__"